import { httpClient } from '@shared/api';
import type { Assistant, AssistantCreate, AssistantPatch } from '../model/types';

/**
 * Все assistants-эндпоинты бэка richat-next.
 * Соответствует richat_backend/api/routers/assistants.py.
 *
 * Auth: cookies (httpOnly), всё через httpClient — он уже шлёт withCredentials.
 */
export const assistantApi = {
  /** POST /assistants/ — создать новый ассистент (всегда новый RAG). */
  async create(payload: AssistantCreate): Promise<Assistant> {
    const response = await httpClient.post<Assistant>('/assistants/', payload);
    return response.data;
  },

  /**
   * GET /assistants/{id} — детали + опционально вложенные коллекции.
   * include — список через запятую, например 'sources,threads'.
   */
  async get(id: string, include?: string): Promise<Assistant> {
    const response = await httpClient.get<Assistant>(`/assistants/${id}`, {
      params: include ? { include } : undefined,
    });
    return response.data;
  },

  /** PATCH /assistants/{id} — частичное обновление. */
  async patch(id: string, payload: AssistantPatch): Promise<Assistant> {
    const response = await httpClient.patch<Assistant>(`/assistants/${id}`, payload);
    return response.data;
  },

  /** V2-4: «Составить инструкцию» по названию и описанию бизнеса (бесплатно для клиента). */
  async composeInstruction(payload: { name: string; description: string; model_id?: number }): Promise<string> {
    const r = await httpClient.post<{ prompt: string }>('/assistants/compose-instruction', payload, {
      timeout: 90_000,
    });
    return r.data.prompt;
  },

  /** V2-4: «Улучшить с помощью ИИ» — новая редакция инструкции (кабинет показывает для принятия). */
  async improveInstruction(id: string, prompt: string): Promise<string> {
    const r = await httpClient.post<{ prompt: string }>(`/assistants/${id}/improve-instruction`, { prompt }, {
      timeout: 90_000,
    });
    return r.data.prompt;
  },

  /** DELETE /assistants/{id} — каскадное удаление. */
  async delete(id: string): Promise<void> {
    await httpClient.delete(`/assistants/${id}`);
  },
};
